'use strict';

angular.module('mean.bids').factory('bidTotalsService', ['$filter', 'taskTotalsService',
    function ($filter, taskTotalsService) {
        //task is from the view that has subtask, materials, quantities, etc...
        //plan is the plan we are updating
        //bid_list is the bid's current bid list
        var updateBid = function (item, plan, bid_list) {
            //do we currently have a bid for this task
            var inlist = $filter('filter')(bid_list, { 'task_id': item._id, 'plan_code': plan }, true);

            if (inlist.length === 0) {
                //create a new bid entry in the bid_list
                bid_list.push({
                    plan_code: plan,
                    task_id: item._id,
                    labor: (item.total_labor) ? item.total_labor : 0,
                    materials: (item.total_materials) ? item.total_materials : 0,
                    equipment: (item.total_equipment) ? item.total_equipment : 0
                });

                for (var i = 0; i < item.subtasks.length; i++) {
                    if (!bid_list[bid_list.length - 1].subtasks)
                        bid_list[bid_list.length - 1].subtasks = [];

                    bid_list[bid_list.length - 1].subtasks.push({
                        task_id: item.subtasks[i]._id,
                        quantity: Number(item.subtasks[i].quantity) ? Number(item.subtasks[i].quantity) : 0,
                        bid_hours: Number(item.subtasks[i].bid_hours) ? Number(item.subtasks[i].bid_hours) : 0,
                        hours_allowed: Number(item.subtasks[i].hours_allowed) ? Number(item.subtasks[i].hours_allowed) : 0,
                        labor: Number(item.subtasks[i].labor) ? Number(item.subtasks[i].labor) : 0
                    });

                    if (item.subtasks[i].materials.length) {
                        for (var j = 0; j < item.subtasks[i].materials.length; j++) {
                            var mat = item.subtasks[i].materials[j];
                            if (!bid_list[bid_list.length - 1].subtasks[i].materials)
                                bid_list[bid_list.length - 1].subtasks[i].materials = [];

                            bid_list[bid_list.length - 1].subtasks[i].materials.push({
                                material_id: mat._id,
                                is_overridden: mat.is_overridden,
                                isInventory: mat.isInventory || false,
                                overridden_quantity: mat.overridden_quantity,
                                quantity: mat.quantity ? mat.quantity : 0,
                                quantity_allowed: mat.quantity_allowed ? mat.quantity_allowed : 0,
                                price_per_order: Number(mat.price_per_order) ? Number(mat.price_per_order) : 0,
                                piece_per_size: Number(mat.piece_per_size) ? Number(mat.piece_per_size) : 0,
                                delivery_price: Number(mat.delivery_price) ? Number(mat.delivery_price) : 0
                            });
                        }
                    }
                    if (item.subtasks[i].equipment.length) {
                        for (var j = 0; j < item.subtasks[i].equipment.length; j++) {
                            var mat = item.subtasks[i].equipment[j];
                            if (!bid_list[bid_list.length - 1].subtasks[i].equipment)
                                bid_list[bid_list.length - 1].subtasks[i].equipment = [];

                            bid_list[bid_list.length - 1].subtasks[i].equipment.push({
                                equipment_id: mat._id,
                                is_overridden: mat.is_overridden,
                                overridden_quantity: mat.overridden_quantity,
                                quantity: mat.quantity ? mat.quantity : 0,
                                quantity_allowed: mat.quantity_allowed ? mat.quantity_allowed : 0,
                                price_per_order: Number(mat.price_per_order) ? Number(mat.price_per_order) : 0,
                                piece_per_size: Number(mat.piece_per_size) ? Number(mat.piece_per_size) : 0,
                                delivery_price: Number(mat.delivery_price) ? Number(mat.delivery_price) : 0
                            });
                        }
                    }
                }
            } else if (inlist.length === 1) {
                var bid = inlist[0];
                //update quantities for the subtasks, materials, and equipment
                bid.labor = item.total_labor ? item.total_labor : 0;
                bid.materials = item.total_materials ? item.total_materials : 0;
                bid.equipment = item.total_equipment ? item.total_equipment : 0;

                bid.subtasks = [];
                for (var i = 0; i < item.subtasks.length; i++) {
                    var tsub = item.subtasks[i];
                    bid.subtasks.push({
                        task_id: tsub._id,
                        quantity: Number(tsub.quantity) ? Number(tsub.quantity) : 0,
                        bid_hours: tsub.bid_hours ? tsub.bid_hours : 0,
                        hours_allowed: Number(tsub.hours_allowed) ? Number(tsub.hours_allowed) : 0,
                        labor: Number(tsub.labor) ? Number(tsub.labor) : 0
                    });

                    bid.subtasks[bid.subtasks.length - 1].materials = [];
                    for (var j = 0; j < tsub.materials.length; j++) {
                        var tmat = tsub.materials[j];
                        bid.subtasks[bid.subtasks.length - 1].materials.push({
                            material_id: tmat._id,
                            quantity: tmat.quantity ? tmat.quantity : 0,
                            is_overridden: tmat.is_overridden,
                            isInventory: tmat.isInventory || false,
                            overridden_quantity: tmat.overridden_quantity,
                            quantity_allowed: tmat.quantity_allowed ? tmat.quantity_allowed : 0,
                            price_per_order: Number(tmat.price_per_order) ? Number(tmat.price_per_order) : 0,
                            piece_per_size: Number(tmat.piece_per_size) ? Number(tmat.piece_per_size) : 0,
                            delivery_price: Number(tmat.delivery_price) ? Number(tmat.delivery_price) : 0,
                        });
                    }

                    bid.subtasks[bid.subtasks.length - 1].equipment = [];
                    for (var j = 0; j < tsub.equipment.length; j++) {
                        var teqt = tsub.equipment[j];
                        bid.subtasks[bid.subtasks.length - 1].equipment.push({
                            equipment_id: teqt._id,
                            is_overridden: teqt.is_overridden,
                            overridden_quantity: teqt.overridden_quantity,
                            quantity: teqt.quantity ? teqt.quantity : 0,
                            quantity_allowed: teqt.quantity_allowed ? teqt.quantity_allowed : 0,
                            price_per_order: Number(teqt.price_per_order) ? Number(teqt.price_per_order) : 0,
                            piece_per_size: Number(teqt.piece_per_size) ? Number(teqt.piece_per_size) : 0,
                            delivery_price: Number(teqt.delivery_price) ? Number(teqt.delivery_price) : 0
                        });
                    }
                }
            } else {
                alert('issue in bidTotalsService. Contact admin');
                return false;
            }

            return true;
        };

        var getHoursAllowedForItem = function (item) {
            item.current_net_pay =
                item.bid_hours ? item.bid_hours * item.crew_rate :
                    item.quantity * item.piece_rate;
            if (!item.piece_per_hour_rate) {
                return item.hours_allowed =
                    taskTotalsService.getHoursAllowed(item.bid_hours,
                        item.current_net_pay, item.crew_rate);
            } else if (item.bid_hours && item.bid_hours !== 0) {
                return item.hours_allowed =
                    taskTotalsService.getHoursAllowed(item.bid_hours,
                        item.current_net_pay, item.crew_rate);
            } else
                return item.hours_allowed = item.quantity / item.piece_per_hour_rate;
        };

        var getCurrentNetPay = function (item) {
            if (item.piece_per_hour_rate && item.piece_per_hour_rate > 0) {
                var hours_allowed = item.quantity / item.piece_per_hour_rate;
                return hours_allowed * item.crew_rate;
            } else {
                return taskTotalsService.getCurrentNetPay(item.bid_allowed,
                    item.crew_rate, item.quantity, item.piece_rate);
            }
        };

        var getQuantityAllowed = function (subtask, material) {
            if (subtask.unit === material.unit) {
                if (material.is_overridden)
                    return material.overridden_quantity;
                else
                    return material.quantity ? material.quantity : subtask.quantity / material.piece_per_size;
            } else
                return material.quantity;
        };

        var getMaterialTotal = function (item, mat) {
            var value;
            if (mat.is_overridden) {
                value = mat.overridden_quantity * mat.price_per_order;
            } else {
                if (mat.quantity)
                    value = mat.quantity * mat.price_per_order;
                else
                    value = getQuantityAllowed(item, mat) * mat.price_per_order;
            }

            return value;
        };

        var getMaterialSubTotal = function (item, mat, taxes) {
            var value = getMaterialTotal(item, mat);
            return value + value * taxes;
        };

        var getDevSubtotal = function (item, mat) {
            var value = 0;

            if (mat.is_overridden) {
                value = mat.overridden_quantity * mat.delivery_price;
            } else {
                value = mat.quantity ? mat.quantity * mat.delivery_price : getQuantityAllowed(item, mat) * mat.delivery_price;
            }

            return value;
        };

        return {
            updateBid: updateBid,
            getHoursAllowedForItem: getHoursAllowedForItem,
            getCurrentNetPay: getCurrentNetPay,
            getQuantityAllowed: getQuantityAllowed,
            getMaterialTotal: getMaterialTotal,
            getMaterialSubTotal: getMaterialSubTotal,
            getDevSubtotal: getDevSubtotal
        };
    }
]);



// WEBPACK FOOTER //
// ./packages/custom/bids/public/services/bid-totals-service.js